import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { withPrefix } from 'gatsby'
import { media } from 'src/styles/styled-components'
import mapboxgl from 'mapbox-gl'

const StyledMap = styled.div`
  flex-shrink: 0;
  height: 200px;
  overflow: hidden;
  width:100%;

  ${ media.tablet`
    margin-left: -40px;
    margin-right: 34px;
    height: 325px;
    width: 305px;
  ` }

  ${ media.desktop`
    margin-left: 0px;
    margin-right: 90px;
    width: 500px;
    height: 345px;
  ` }
`

class ArMap extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }
  static propTypes = {
    lat: PropTypes.string,
    lng: PropTypes.string,
  }

  componentDidMount () {
    if (typeof window === 'undefined' || typeof mapboxgl === 'undefined') return
    mapboxgl.accessToken = process.env.MAPBOX_TOKEN
    const map = new mapboxgl.Map({
      container: this.mapContainer,
      style: 'mapbox://styles/artificial/ciww4o97g00mf2qqygbiyob9z',
      center: [this.props.lng, this.props.lat],
      zoom: 14,
    })

    let el = document.createElement('div')
    el.style.width = `82px`
    el.style.height = `92px`
    el.style.backgroundImage = `url(${ withPrefix('img/marker.png') })`
    el.style.backgroundRepeat = `no-repeat`
    el.style.backgroundSize = `contain`

    new mapboxgl.Marker(el)
      .setLngLat([this.props.lng, this.props.lat])
      .addTo(map)
  }

  render () {
    return (
      <StyledMap ref={el => { this.mapContainer = el }} />
    )
  }
}

export default ArMap
